import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

interface IProps {
    className?: string;
    style?: any;
}

export const Video: React.FunctionComponent<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 64 64" {...props}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <rect fillRule="nonzero" x="0" y="0" width="64" height="64"></rect>
                    <g transform="translate(7.000000, 15.000000)" stroke="currentColor" strokeWidth="3">
                        <rect x="0" y="0" width="50" height="35" rx="2"></rect>
                        <polygon strokeLinejoin="round" points="20 7.5 20 27.5 35 17.5"></polygon>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
